module.exports = __webpack_public_path__ + "img/confirmed.76c02fc1.png";